import React from 'react';
import './VerifiedBadge.css';

const VerifiedBadge = ({ size = 16, title = "Verificado" }) => {
    return (
        <span className="verified-badge-container" title={title}>
            <svg
                viewBox="0 0 24 24"
                width={size}
                height={size}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    fill="#1DA1F2"
                />
                <path
                    d="M7.5 12L10.5 15L16.5 9"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default VerifiedBadge;
